/**
 * Institution photography — the buildings themselves.
 *
 * The gallery sweep crawled the source's /media/ tree, which turned out to be
 * event photography almost end to end; its actual building shots sit under
 * /static/assets/images/home/ and were only found later. Ingested through
 * scripts/ingest-images.py on 2026-08-08 into sites/biet/campus/.
 *
 * Source: https://www.bietdvg.edu/ (home page banners 111.jpeg and 4th.jpeg,
 * renamed on ingest — the originals are 4506px and 4117px wide).
 */
import type { Media } from "@zivin-labs/site-content";

/** The main academic block, BIET signage over the entrance, seen across the lawn. */
export const MAIN_BLOCK: Media = {
  url: "sites/biet/campus/biet-main-block.jpg",
  alt: "The main academic block at BIET, seen across the front lawn",
  width: 2560,
  height: 1490,
};

/** A departmental block along the campus road — a wide, banner-shaped frame. */
export const ACADEMIC_BLOCK: Media = {
  url: "sites/biet/campus/biet-academic-block.jpg",
  alt: "A departmental block along the campus road at BIET",
  width: 2560,
  height: 1044,
};
